import { Button, Card, CardFooter, CardHeader, Heading, Stack } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

import { Page } from './Page';

export const BookingCancelledPage = ({ requestId }: { requestId: string }) => {
  const navigate = useNavigate();

  return (
    <Page title="Booking Cancelled" flex="1">
      <Card shadow="md" maxW="sm" margin="auto" marginY="40" px="4" py="3">
        <CardHeader fontWeight="bold" p="0">
          <Heading variant="h5">Booking Cancelled!</Heading>
        </CardHeader>
        <CardFooter p="0">
          <Stack direction="row" spacing="4" justify="flex-end" w="full">
            <Button onClick={() => navigate(`/requests/${requestId}`)}>Return to Quotes Listing</Button>
            <Button colorScheme="primary" onClick={() => navigate('/')}>
              New Request
            </Button>
          </Stack>
        </CardFooter>
      </Card>
    </Page>
  );
};
